import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  ButtonGroup,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  SwipeableDrawer,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { AccountCircle, Close } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import {
  getDevSkills,
  addDesvSkill,
  updateDevSkill,
  getDevSkill,
  deleteDevSkill,
} from "../../features/Dev/skillSlice";
import {
  closeSnackBar,
  openSnackBar,
} from "../../features/modals/snackBarSlice";

const Skill = () => {
  const [createModal, setCreateModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  let { skills, skill } = useSelector((state) => state.skill);
  const { dev } = useSelector((state) => state.dev);

  const [skillId, setSkillId] = useState("");
  let [editLogs, setEditLogs] = useState({
    skill: skill?.attributes.skill,
    type: skill?.attributes.type,
    experience: skill?.attributes.experience,
    logo: skill?.attributes.logo,
    id: skill?.id,
  });
  console.log(editLogs);

  const [logs, setLogs] = useState({
    skill: "",
    type: "",
    experience: "",
    logo: "",
    id: "",
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDevSkills());
    setEditLogs({
      ...editLogs,
      skill: skill?.attributes.skill,
      type: skill?.attributes.type,
      experience: skill?.attributes.experience,
      logo: skill?.attributes.logo,
      id: skill?.id,
    });
  }, [skill]);

  // ? get dev skill by id for edit
  // const getSkill = (id) => {
  //   dispatch(getDevSkill(id));
  //   setEditLogs({
  //     ...editLogs,
  //     skill: skill.skill,
  //     type: skill.type,
  //     experience: skill.experience,
  //     logo: skill.logo,
  //   });
  // };

  const handleOpen = () => {
    setCreateModal(true);
  };

  const handleClose = () => {
    setCreateModal(false);
  };

  const handleEditModal = (id) => {
    // setSkillId(id);
    // getSkill(id);
    // setEditLogs({
    //   ...editLogs,
    //   skill: skill?.skill,
    //   type: skill?.type,
    //   experience: skill?.experience,
    //   logo: skill?.logo,
    // });
    dispatch(getDevSkill(id));
    setEditLogs({
      ...editLogs,
      skill: skill?.attributes.skill,
      type: skill?.attributes.type,
      experience: skill?.attributes.experience,
      logo: skill?.attributes.logo,
      id: skill?.id,
    });
    setEditModal(true);
  };

  const handleCloseEditModal = () => {
    setEditLogs({
      skill: "",
      type: "",
      experience: "",
      logo: "",
      id: "",
    });
    dispatch(getDevSkills());
    setEditModal(false);
  };

  const handleChange = (e) => {
    setLogs({
      ...logs,
      id: dev.id,
      [e.target.name]: e.target.value,
    });
  };

  const handleEditChange = (e) => {
    setEditLogs({
      ...editLogs,
      id: skill?.id,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddSkillSubmit = (e) => {
    e.preventDefault();
    dispatch(addDesvSkill(logs));
    dispatch(
      openSnackBar({
        message: "skill added successfully",
      })
    );
  };

  const handleUpdateSubmit = (e) => {
    e.preventDefault();
    dispatch(updateDevSkill(editLogs));
    dispatch(openSnackBar({ message: "updated successfully" }));
    // handleOpenSnackbar();
  };

  const handleDeleteSkill = (id) => {
    dispatch(deleteDevSkill(id));
    dispatch(getDevSkills());
  };

  return (
    <>
      <Container
        maxWidth="lg"
        sx={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          // height: "80vh",
        }}
      >
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: "100%" }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Id</TableCell>
                <TableCell align="right">Name</TableCell>
                <TableCell align="right">Type</TableCell>
                <TableCell align="right">Experience</TableCell>
                <TableCell align="right">Logo</TableCell>
                <TableCell align="right">
                  Action{" "}
                  <Button variant="outlined" onClick={handleOpen}>
                    create{" "}
                  </Button>{" "}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {skills?.length > 0 &&
                skills?.map((skill) => (
                  <TableRow
                    key={skill?.id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {skill?.id}
                    </TableCell>
                    <TableCell align="right">
                      {skill?.attributes.skill}
                    </TableCell>
                    <TableCell align="right">
                      {skill?.attributes.type}
                    </TableCell>
                    <TableCell align="right">
                      {skill?.attributes.experience}
                    </TableCell>
                    <TableCell align="right">
                      <Avatar alt="Remy Sharp" src={skill?.attributes.logo} />
                    </TableCell>
                    <TableCell align="right">
                      <ButtonGroup size="large" aria-label="large button group">
                        <Button
                          onClick={() => handleEditModal(skill.id)}
                          color="primary"
                        >
                          Edit
                        </Button>
                        <Button
                          onClick={() => handleDeleteSkill(skill.id)}
                          color="error"
                        >
                          Delete
                        </Button>
                      </ButtonGroup>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
      <SwipeableDrawer anchor="bottom" open={createModal} onClose={handleClose}>
        <Container>
          <DialogTitle>Create a skill</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please fill in all appropraite filds
            </DialogContentText>
            <Box component="form" onSubmit={handleAddSkillSubmit}>
              <Paper elevation={2}>
                <Box sx={{ p: 2 }}>
                  <Box>
                    <Typography variant="h5">
                      {" "}
                      Please fill all fields
                    </Typography>
                  </Box>

                  <Box component="form" onSubmit={handleAddSkillSubmit} py={2}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <AccountCircle
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            id="input-with-sx"
                            label="skills"
                            variant="standard"
                            fullWidth
                            name="skill"
                            onChange={handleChange}
                            value={logs.skill}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          {/* <AccountCircle
                          sx={{ color: "action.active", mr: 1, my: 0.5 }}
                        /> */}
                          {/* <TextField
                          id="input-with-sx"
                          label="type"
                          variant="standard"
                          fullWidth
                        /> */}

                          <FormControl sx={{ m: 1, minWidth: 120 }}>
                            <InputLabel id="demo-simple-select-helper-label">
                              skill Type
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-helper-label"
                              id="demo-simple-select-helper"
                              value={logs.type}
                              label="Skill Type"
                              onChange={handleChange}
                              name="type"
                            >
                              <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                              <MenuItem value="Front End">Front End</MenuItem>
                              <MenuItem value="Back End">Back End</MenuItem>
                              <MenuItem value="Graphics">Graphics</MenuItem>
                              <MenuItem value="UI/UX">Ui/Ux</MenuItem>
                              <MenuItem
                                value="Product
                        Designer"
                              >
                                Product Designer
                              </MenuItem>
                            </Select>
                            <FormHelperText>select skill type</FormHelperText>
                          </FormControl>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <AccountCircle
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            id="input-with-sx"
                            label="experiance "
                            variant="standard"
                            fullWidth
                            type="number"
                            name="experience"
                            onChange={handleChange}
                            value={logs.experience}
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <AccountCircle
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            id="input-with-sx"
                            label="logo"
                            variant="standard"
                            fullWidth
                            type="url"
                            name="logo"
                            onChange={handleChange}
                            value={logs.logo}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Button variant="outlined" size="small" type="submit">
                      Add Skill
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="error" variant="outlined">
              close
            </Button>
          </DialogActions>
        </Container>
      </SwipeableDrawer>

      <SwipeableDrawer
        anchor="bottom"
        open={editModal}
        onClose={handleCloseEditModal}
      >
        <DialogTitle>Edit a skill</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please fill in all appropraite filds
          </DialogContentText>
          <Box component="form" onSubmit={handleUpdateSubmit}>
            <Paper p={2} elevation={2}>
              <Box sx={{ p: 2 }}>
                <Box>
                  <Typography variant="h5"> Please fill all fields</Typography>
                </Box>

                <Box py={2}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                        <AccountCircle
                          sx={{ color: "action.active", mr: 1, my: 0.5 }}
                        />
                        <TextField
                          id="input-with-sx"
                          label="skills"
                          variant="standard"
                          fullWidth
                          name="skill"
                          onChange={handleEditChange}
                          value={editLogs?.skill}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                        {/* <AccountCircle
                          sx={{ color: "action.active", mr: 1, my: 0.5 }}
                        /> */}
                        {/* <TextField
                          id="input-with-sx"
                          label="type"
                          variant="standard"
                          fullWidth
                        /> */}

                        <FormControl sx={{ m: 1, minWidth: 120 }}>
                          <InputLabel id="demo-simple-select-helper-label">
                            skill Type
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-helper-label"
                            id="demo-simple-select-helper"
                            value={editLogs?.type}
                            label="Skill Type"
                            onChange={handleEditChange}
                            name="type"
                          >
                            <MenuItem value="">
                              <em>None</em>
                            </MenuItem>
                            <MenuItem value="Front End">Front End</MenuItem>
                            <MenuItem value="Back End">Back End</MenuItem>
                            <MenuItem value="Graphics">Graphics</MenuItem>
                            <MenuItem value="UI/UX">Ui/Ux</MenuItem>
                            <MenuItem
                              value="Product
                        Designer"
                            >
                              Product Designer
                            </MenuItem>
                          </Select>
                          <FormHelperText>select skill type</FormHelperText>
                        </FormControl>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                        <AccountCircle
                          sx={{ color: "action.active", mr: 1, my: 0.5 }}
                        />
                        <TextField
                          id="input-with-sx"
                          label="experiance "
                          variant="standard"
                          fullWidth
                          type="number"
                          name="experience"
                          onChange={handleEditChange}
                          value={editLogs?.experience}
                        />
                      </Box>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                        <AccountCircle
                          sx={{ color: "action.active", mr: 1, my: 0.5 }}
                        />
                        <TextField
                          id="input-with-sx"
                          label="logo"
                          variant="standard"
                          fullWidth
                          type="url"
                          name="logo"
                          onChange={handleEditChange}
                          value={editLogs?.logo}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Button variant="outlined" size="small" type="submit">
                    Edit Skill
                  </Button>
                </Box>
              </Box>
            </Paper>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseEditModal}
            color="error"
            variant="outlined"
          >
            close
          </Button>
        </DialogActions>
      </SwipeableDrawer>
    </>
  );
};

export default Skill;
